module.exports = __webpack_public_path__ + "static/media/rest.7ef86246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/rest.png
// module id = 112
// module chunks = 0